<template>
  <b-row>
    <b-col cols="12">
      <email-sender-content />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import EmailSenderContent from './EmailSenderContent.vue'

export default {
  components: {
    BRow,
    BCol,

    EmailSenderContent
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
